function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5604 51.028C11.5025 51.028 0.0932617 39.6187 0.0932617 25.5609C0.0932617 11.503 11.5025 0.09375 25.5604 0.09375C39.6182 0.09375 51.0275 11.503 51.0275 25.5609C51.0275 39.6187 39.6182 51.028 25.5604 51.028ZM34.7123 26.3391C35.2297 25.951 35.2297 25.1749 34.7123 24.7868L22.0192 15.267C21.3796 14.7873 20.4669 15.2436 20.4669 16.0431V35.0828C20.4669 35.8823 21.3796 36.3386 22.0192 35.8589L34.7123 26.3391Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5604 51.028C11.5025 51.028 0.0932617 39.6187 0.0932617 25.5609C0.0932617 11.503 11.5025 0.09375 25.5604 0.09375C39.6182 0.09375 51.0275 11.503 51.0275 25.5609C51.0275 39.6187 39.6182 51.028 25.5604 51.028ZM34.7123 26.3391C35.2297 25.951 35.2297 25.1749 34.7123 24.7868L22.0192 15.267C21.3796 14.7873 20.4669 15.2436 20.4669 16.0431V35.0828C20.4669 35.8823 21.3796 36.3386 22.0192 35.8589L34.7123 26.3391Z",
  fill: "white"
});

function SvgPlayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.612b09ea.svg";
export { ForwardRef as ReactComponent };